import { Injectable, computed, signal } from '@angular/core';
import { environment } from '../../../environments/environment';
import type { TenantConfig } from './tenant-config';

/**
 * Contexte tenant runtime. Résout le `tenantId` du build courant depuis
 * `environment.tenant` (posé par `generate-tenant.mjs` pour un build white-label).
 * En build mono-marque par défaut, `environment.tenant` est absent → `tenantId = null`
 * et le comportement reste strictement inchangé. Phase 10.
 */
@Injectable({ providedIn: 'root' })
export class TenantContext {
  // Lecture défensive : le build mono-marque n'a pas de champ `tenant`.
  private readonly cfg = (environment as unknown as { tenant?: TenantConfig }).tenant ?? null;

  readonly tenant = signal<TenantConfig | null>(this.cfg);
  readonly tenantId = computed(() => this.tenant()?.tenantId ?? null);
  readonly isWhiteLabel = computed(() => this.tenantId() !== null);

  /**
   * Ajoute `tenantId` aux NOUVEAUX writes d'une app white-label (additif, non
   * rétroactif — la donnée mono-marque existante n'est pas migrée en v1).
   */
  withTenant<T extends Record<string, unknown>>(data: T): T & { tenantId?: string } {
    const id = this.tenantId();
    return id ? { ...data, tenantId: id } : data;
  }
}
